import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import CtaButton from '../ctaButton/ctaButton';
import styles from './socialProof.module.scss';
import GeneratingStars from './Reviews/helpers/generatingStar';
import SmartImage from '../smartImage/smartImage';

export default function SocialProof({
  headline = '',
  rating = '',
  description = '',
  heroImage = {},
  cta = {},
  items = [],
}) {
  return (
    <div className={styles.socialProof}>
      <div className={styles.header}>
        <h2 className={styles.title}>{headline}</h2>
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.rating}>
            <GeneratingStars rating={rating} />
          </div>
          <div className={styles.text}>{parse(`${description}`)}</div>
          {cta && (
            <CtaButton
              aria-label="Read More Reviews "
              label={cta?.label}
              variant={cta?.variant}
              color={cta?.color}
              fullWidth
              className={styles.cta}
              href={cta?.link}
            />
          )}
          {items?.length > 0 && (
            <div className={styles.reviews}>
              {items?.map((item, index) => {
                const key = `review-${index}`;
                return (
                  <div key={key} className={styles.column}>
                    <SmartImage
                      loading="lazy"
                      src={item?.src}
                      alt={item?.alt}
                      width={item.width}
                      height={item.height}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className={styles.gap} />
        <div className={styles.imageSection}>
          <SmartImage
            loading="lazy"
            alt={heroImage?.alt}
            src={heroImage?.src}
            width={heroImage.width}
            height={heroImage.height}
          />
        </div>
      </div>
    </div>
  );
}

SocialProof.propTypes = {
  rating: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ),
  headline: PropTypes.string,
  heroImage: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  description: PropTypes.string,
  cta: PropTypes.shape({
    link: PropTypes.string,
    text: PropTypes.string,
  }),
};
